export type ComparisonRow = {
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    without: '100+ hours/year planning from scratch',
    with: '5 minutes/week. Everything ready.',
  },
  {
    without: 'Same 10 drills repeated with no progression',
    with: '150+ drills organised by level',
  },
  {
    without: 'Students improving slowly and losing motivation',
    with: 'Clear, measurable level progression',
  },
  {
    without: 'Cancelled classes when it rains',
    with: '10 indoor sessions always ready',
  },
  {
    without: 'Arriving at the court unprepared',
    with: 'Walk on court confident every single time',
  },
  {
    without: 'No visible system — parents doubt your method',
    with: 'Structured, credible, professional coach',
  },
]

export const problems: string[] = [
  'Spending hours every week planning sessions from scratch',
  'Running out of drills and repeating the same exercises',
  'Not knowing how to structure a full season progression',
  'Struggling to manage groups with mixed ability levels',
  'Having no system to track and show student development',
  'Arriving at the court without a clear plan in place',
  'Losing income every time a student cancels last minute',
  'Feeling like you should be doing more but not knowing how',
]

export const packageIncludes: string[] = [
  '12 Complete Volumes — every level covered',
  '6 Strategic Bonuses — included free',
  '150+ Professional Drills with diagrams',
  '280+ Pages of ready-to-use content',
  'Lifetime Access — yours forever',
  'Mobile + A4 Print Optimised PDFs',
]
